import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#1a0000] py-12 px-4" data-id="element-253">
      <div className="max-w-2xl mx-auto text-center" data-id="element-254">
        <h2 className="text-xl sm:text-2xl font-black text-white mb-6" data-id="element-255">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>

        <div className="mb-5" data-id="element-256">
          <CountdownTimer size="md" blinking={true} data-id="element-257" />
        </div>

        <p className="text-white text-base font-bold mb-8" data-id="element-258">
          Después sube{' '}
          <span className="text-[#FF8A80] font-black" data-id="element-259">$8.000 ARS</span> y no
          vuelve a bajar.
        </p>

        {/* Progress bar */}
        <div className="mb-4" data-id="element-260">
          <div className="flex items-center justify-between mb-2" data-id="element-261">
            <span className="text-[#FF8A80] font-bold text-xs sm:text-sm" data-id="element-262">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-white text-xs sm:text-sm font-bold" data-id="element-263">
              Quedan pocos
            </span>
          </div>
          <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden" data-id="element-264">
            <div className="h-full rounded-full bg-gradient-to-r from-[#FF0000] to-[#FF6600]" style={{
            width: '68%'
          }} data-id="element-265" />
          </div>
          <p className="text-gray-400 text-[10px] sm:text-xs mt-1.5 text-right" data-id="element-266">
            68% de los cupos tomados
          </p>
        </div>
      </div>
    </section>;
}